import { Receipt } from 'lucide-react';
import { useWallet } from '../../../../context/wallet/WalletContext';
import WalletTransactionRow from './WalletTransactionRow';

const WalletTransactionsTable = () => {
  const { isLoading, filteredTransactions } = useWallet();

  return (
    <div className="hidden md:block overflow-x-auto">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="border-b border-slate-100 bg-slate-50/70 text-[10px] font-bold text-slate-400 uppercase tracking-widest">
            <th className="py-3 px-4">Transaction Type</th>
            <th className="py-3 px-4">Details &amp; Reference</th>
            <th className="py-3 px-4">Date &amp; Time</th>
            <th className="py-3 px-4">Status</th>
            <th className="py-3 px-4 text-right">Amount (INR)</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="5" className="p-12 text-center text-slate-400 text-xs">
                <div className="w-7 h-7 border-2 border-[#067978] border-t-transparent rounded-full animate-spin mx-auto mb-2" />
                Loading wallet transactions...
              </td>
            </tr>
          ) : filteredTransactions.length === 0 ? (
            <tr>
              <td colSpan="5" className="p-12 text-center text-slate-400">
                <div className="w-12 h-12 rounded-2xl bg-slate-50 border border-dashed border-slate-200 flex items-center justify-center mx-auto mb-2 text-slate-400">
                  <Receipt size={22} />
                </div>
                <p className="text-xs font-semibold text-slate-700">No transactions found</p>
                <p className="text-[11px] text-slate-400 mt-0.5">
                  Earnings will appear here automatically when travellers complete bookings.
                </p>
              </td>
            </tr>
          ) : (
            filteredTransactions.map((tx) => <WalletTransactionRow key={tx._id} tx={tx} />)
          )}
        </tbody>
      </table>
    </div>
  );
};

export default WalletTransactionsTable;
